export enum SupportedEnvironment {
    staging,
    production,
    develop
}